import React, { memo } from 'react'
import { Box, Card, CardHeader } from '@mui/material'

import { PERKS_PRICING } from '../../util/staking/perks.helpers'
import PerkItem from './PerkItem'

const Perks = ({ t, userTier: { tier }, onOpenPerk }) => {
  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        title={t('brand:perk.title')}
        subheader={t('brand:perk.desc')}
      />
      <Box
        sx={{
          p: 3,
          gap: 3,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {PERKS_PRICING.map(({ id, productId, price }) => {
          return (
            <PerkItem
              key={id}
              t={t}
              id={id}
              productId={productId}
              amount={price[tier.id - 1]}
              onOpenPerk={onOpenPerk}
            />
          )
        })}
      </Box>
    </Card>
  )
}

export default memo(Perks)
